// Edit on a dashboard or report (see EditInStudioOption):
// /studio/dashboard/:id?returnTo=<where it was opened> brings Back (and Save)
// to where it was opened, e.g. inside a workspace or app, rather than to the
// content's own page. Studio's other params come and go without it.
export const RETURN_TO_PARAM = 'returnTo';

// Studio opened from returnTo itself, so the entry before Studio's is it:
// Back (and Save) go back to it rather than pushing it again, leaving the
// browser's Back (and the content's own) to where it was before that
export type ReturnToState = { isOpenedFromReturnTo: true };

export const RETURN_TO_STATE: ReturnToState = { isOpenedFromReturnTo: true };

export const isOpenedFromReturnTo = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as Partial<ReturnToState>).isOpenedFromReturnTo === true;

// Only a path within the app: anything else (another site, a
// protocol-relative or backslashed URL) is ignored
export const toReturnPath = (value: string | null): string | undefined =>
  value &&
  value.startsWith('/') &&
  !value.startsWith('//') &&
  !value.includes('\\')
    ? value
    : undefined;
